import { Link } from "react-router-dom";
import { formatInr } from "@/lib/api";

export default function ProductCard({ p }) {
  return (
    <Link to={`/products/${p.slug}`} data-testid={`product-card-${p.slug}`} className="fm-card group block">
      <div className="aspect-[4/3] w-full bg-[var(--fm-sage)] overflow-hidden">
        <img src={p.image} alt={p.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" />
      </div>
      <div className="p-5">
        <div className="overline text-[var(--fm-text-3)]">{p.brand}</div>
        <h3 className="font-display text-xl mt-1 leading-snug text-[var(--fm-text)] tracking-tight">{p.name}</h3>
        <p className="text-sm text-[var(--fm-text-2)] mt-2 line-clamp-2">{p.short_description}</p>
        <div className="flex items-baseline gap-3 mt-4">
          <span className="font-mono-fm text-lg text-[var(--fm-primary)] font-semibold">{formatInr(p.price)}</span>
          {p.mrp && p.mrp > p.price && (
            <span className="font-mono-fm text-xs text-[var(--fm-text-3)] line-through">{formatInr(p.mrp)}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
